import { render, staticRenderFns } from "./TabListingv1.vue?vue&type=template&id=30ec6138&"
import script from "./TabListingv1.vue?vue&type=script&lang=js&"
export * from "./TabListingv1.vue?vue&type=script&lang=js&"
import style0 from "./TabListingv1.vue?vue&type=style&index=0&id=30ec6138&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports